import { render, staticRenderFns } from "./AppButton2.vue?vue&type=template&id=15ad6dfd&"
import script from "./AppButton2.vue?vue&type=script&lang=js&"
export * from "./AppButton2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports